import {
    audience
} from '../../api/auction';
const handleError = (url, id) => {
    console.log(url, id + ':错误信息')
}
export default {
    getAudienceSearch({
        commit
    }, [param, fn]) {
        return audience(param).then(
            myDatas => {
                // console.log("myDatas",myDatas);
                myDatas = JSON.parse(JSON.stringify(myDatas))
                let data = myDatas.data;
                if (typeof (data) != "object" || typeof (data) == "undefined") {
                    var myData = {
                        code: -1,
                    }
                    commit('fillToPageSpecialSearch', myData);
                    //设置顶级mate信息
                    commit('setArtistHomeMeta', myData, {
                        root: true
                    })
                    console.log("indexBanner->Meta=>未正确请求接口数据");
                } else {
                    commit('fillToPageSpecialSearch', data);
                    //设置顶级mate信息
                    commit('setArtistHomeMeta', data, {
                        root: true
                    })
                }
                if (fn != undefined) fn()
            }
        ).catch(err => {
            console.log(err);
            // console.log("getArtistHome",'artCode:'+id)
            handleError("getAudienceSearch", param);
        })
    }
}